<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">
          노선 설정
          <v-btn depressed rounded outlined color="secondary" class="ml-5"
            @click="setCreateMode"
             v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
          >
            <v-icon>add</v-icon> 노선 추가
          </v-btn>
        </h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="rawData.routeGroupList && rawData.routeGroupList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(item, idx) in rawData.routeGroupList"
                      :key="idx"
                      :class="['content-menu__item with--depth', {'is--active' : activeIndex === idx}, {'content-menu__item--only': item.stations && item.stations.length === 0}]"
                    >
                      <div v-if="isInvalidItem(item)" class="menu__item-main" style="color: red" @click="selectMainItem(idx)">
                        <div>
                          {{ item.name }}
                          <v-icon v-if="isInvisibleItem(item)">visibility_off</v-icon>
                        </div>
                        <v-icon v-if="item.routes.length > 0">keyboard_arrow_down</v-icon>
                      </div>
                      <div v-else class="menu__item-main" @click="selectMainItem(idx)">
                        <div>
                          {{ item.name }}
                          <v-icon v-if="isInvisibleItem(item)">visibility_off</v-icon>
                        </div>
                        <v-icon v-if="item.routes.length > 0">keyboard_arrow_down</v-icon>
                      </div>
                      <div v-if="item.routes && item.routes.length > 0">
                        <ul class="content-menu-list-deep" >
                          <li v-for="(route, index) in rawData.routeList.filter(x => item.routes.includes(x.id))"
                              :key="index"
                              @click="selectItem(index), setCurrentRoute(route)"
                              :class="['list-deep__item', { 'is--active' : activeChildIndex === index }]">
                            <div v-if="isInvalidRoute(route)" style="color: red">
                              {{ route.name }}
                              <v-icon v-if="isInvisibleRoute(route)">visibility_off</v-icon>
                            </div>
                            <div v-else>
                              {{ route.name }}
                              <v-icon v-if="isInvisibleRoute(route)">visibility_off</v-icon>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="rawData.routeGroupList && rawData.routeGroupList.length === 0">등록된 노선그룹이 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-if="route && route.id || mode === 'CREATE'"
                  >
                    <v-container class="pa-lg-10 pt-lg-7">
                      <v-row class="pa-2">
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">노선그룹</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-select
                            :items="option.routeGroupOption"
                            v-model="route.routeGroup"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">노선이름</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-text-field class="pt-0 mb-5" hide-details required
                            v-model="route.name"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">출발지</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0 mb-5">
                          <v-text-field hide-details class="pt-0"
                            v-model="route.src"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">도착지</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0 mb-0">
                          <v-text-field hide-details class="pt-0"
                            v-model="route.dst"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-0 mb-0">
                          <v-checkbox
                            v-model="route.visible"
                            label="앱에 표시하기"/>
                        </v-col>
                        <v-col class="pa-0 pt-2 pb-0" justify="end">
                          <v-row>created : {{ route.createdDate }}</v-row>
                          <v-row>updated : {{ route.updatedDate }}</v-row>
                        </v-col>
                        <v-col cols="12" class="pa-0 mt-6 mb-2">
                          <v-subheader class="pa-0 form-label--separate">버스 배차
                          </v-subheader>
                        </v-col>
                        <v-col
                          v-for="(busDispatch, dIndex) in (route.busDispatchList || []).filter(x => x.remove !== true)"
                          :key="dIndex"
                          cols="12" class="pa-0 pt-4">
                          <v-card
                            class="mx-auto bus-route-content"
                            outlined
                          >
                            <v-row class="pa-5 pt-0 pb-0" align="center">
                              <v-col cols="4">
                                <v-select
                                  :items="option.busOption"
                                  v-model="busDispatch.bus"
                                  @change="setUpdated(dIndex)"
                                  label="버스"
                                  hide-details
                                ></v-select>
                              </v-col>
                              <v-col cols="3">
                                <v-checkbox
                                  v-model="busDispatch.visible"
                                  @change="setUpdated(dIndex)"
                                  label="앱에 표시하기"/>
                              </v-col>
                              <v-col cols="2" class="pa-0">
                                <v-btn
                                  v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                                  class="mx-2" fab outlined dark x-small depressed color="error"
                                  @click="removeBusDispatch(dIndex)"
                                >
                                  <v-icon dark>mdi-minus</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col class="pa-0 pt-0 pb-0" justify="end">
                                <v-row>created : {{ busDispatch.createdDate}}</v-row>
                                <v-row>updated : {{ busDispatch.updatedDate}}</v-row>
                              </v-col>
                            </v-row>
                            <v-row class="pa-14 pt-0 pb-2" align="center" justify="center">
                              <v-col cols="3" class="pt-0 pb-0">
                                <v-select
                                  :items="option.dayOption"
                                  v-model="busDispatch.week"
                                  @change="setUpdated(dIndex)"
                                  hide-details
                                  label="요일"
                                ></v-select>
                              </v-col>
                              <v-col cols="3" class="pt-0 pb-0">
                                <v-select
                                  :items="option.directionOption"
                                  v-model="busDispatch.toChurch"
                                  @change="setUpdated(dIndex)"
                                  hide-details
                                  label="방향"
                                ></v-select>
                              </v-col>
                              <v-col cols="3" class="pt-0 pb-0">
                                <v-select
                                  :items="option.driverOption"
                                  v-model="busDispatch.driver"
                                  @change="setUpdated(dIndex)"
                                  hide-details
                                  label="운전자"
                                ></v-select>
                              </v-col>
                              <v-col cols="3" class="pt-0 pb-0">
                                <v-select
                                  :items="option.typeOption"
                                  v-model="busDispatch.type"
                                  @change="setUpdated(dIndex)"
                                  hide-details
                                  label="운행"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row class="pa-11 pt-0 pb-0" align="center"  justify="center">
                              <v-col cols="12" class="pt-0 pb-0">
                                <ol>
                                  <li v-for="(station, sIndex) in (busDispatch.stationList || []).filter(x => x.remove !== true)"
                                      :key="sIndex"
                                  >
                                    <v-row class="pa-5 pt-0 pb-0" align="center">
                                      <v-col cols="4" class="pt-0">
                                        <v-select
                                          :items="option.stationOption.filter(x => {
                                            for (const i in x.routeGroups) {
                                              let rg = x.routeGroups[i]
                                              if (rg === route.routeGroup) {
                                                return true
                                              }
                                            }
                                            return false
                                            // return x.routeGroup === route.routeGroup
                                          })"
                                          v-model="station.station"
                                          @change="setUpdated(dIndex, sIndex)"
                                          label="정류장선택"
                                          hide-details />
                                      </v-col>
                                      <v-col cols="3" class="pt-0">
                                        <v-text-field
                                          v-model="station.hour"
                                          @change="setUpdated(dIndex, sIndex)"
                                          label="시"
                                          type="number"
                                          hide-details
                                          prepend-icon="query_builder"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="3" class="pt-0">
                                        <v-text-field
                                          v-model="station.min"
                                          @change="setUpdated(dIndex, sIndex)"
                                          label="분"
                                          type="number"
                                          hide-details
                                          prepend-icon="query_builder"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="2" class="pa-0" v-if="$store.state.userInfo && $store.state.userInfo.writeBus">
                                        <v-btn class="mx-2" outlined fab dark x-small depressed color="error"
                                          @click="removeBusDispatchStation(dIndex, sIndex)"
                                        >
                                          <v-icon dark>mdi-minus</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </li>
                                </ol>
                                <v-btn class="mt-5 ml-3" dark depressed small color="secondary" rounded outlined
                                  @click="addBusDispatchStation(dIndex)"
                                   v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                                >
                                  <v-icon dark>mdi-plus</v-icon> 정류장추가
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                        <v-col cols="12"  class="text-left mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                            class="ml-3" dark depressed small color="secondary" rounded outlined
                            @click="addBusDispatch"
                          >
                            <v-icon dark>mdi-plus</v-icon> 버스추가
                          </v-btn>
                        </v-col>
                        <v-col cols="12"  class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                            color="primary"
                            class="mt-4"
                            rounded
                            depressed
                            @click="onSubmit"
                            large
                          >
                            {{ mode === 'CREATE' ? '등록하기' : '수정하기'}}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="mt-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus && route.id "
                            color="error"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveRoute">
                            <v-icon>remove</v-icon>
                            노선제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 노선이 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import eventBus from '../utils/eventBus'
import { route, routeGroup, bus, busDispatch, busDispatchStation, station, driver } from '../api'

export default {
  components: {
  },
  data: () => ({
    model: null,
    rawData: {
      routeGroupList: null,
      routeList: [],
      busDispatchList: [],
      busDispatchStationList: []
    },
    option: {
      stationOption: [],
      driverOption: [],
      busOption: [],
      routeGroupOption: [],
      dayOption: [
        { text: '일요일', value: 'SUNDAY' },
        { text: '월요일', value: 'MONDAY' },
        { text: '화요일', value: 'WEDNESDAY' },
        { text: '수요일', value: 'SATURDAY' },
        { text: '목요일', value: 'THURSDAY' },
        { text: '금요일', value: 'TUESDAY' },
        { text: '토요일', value: 'FRIDAY' }
      ],
      directionOption: [
        { text: '교회행', value: true },
        { text: '현장행', value: false }
      ],
      typeOption: [
        { text: '그외', value: null },
        { text: '주일1부', value: 'SUN1' },
        { text: '주일2부', value: 'SUN2' },
        { text: '구역공과', value: 'AREA' }
      ]
    },
    route: {},
    mode: null,
    activeIndex: null,
    activeChildIndex: null
  }),
  created () {
    this.fetchRawData()
    this.fetchDriver()
    this.fetchBus()
    this.fetchStation()
  },
  methods: {
    fetchRawData () {
      this.fetchRouteGroup()
      this.fetchRoute()
      this.fetchBusDispatch()
      this.fetchBusDispatchStation()
    },
    async fetchRouteGroup () {
      const { data } = await routeGroup.list()
      this.rawData.routeGroupList = data
      this.option.routeGroupOption = data.map(x => {
        return { text: `${x.name}`, value: x.id }
      }, [])
    },
    async fetchRoute () {
      const { data } = await route.list()
      this.rawData.routeList = data
    },
    async fetchBusDispatch () {
      const { data } = await busDispatch.list()
      this.rawData.busDispatchList = data
    },
    async fetchBusDispatchStation () {
      const { data } = await busDispatchStation.list()
      this.rawData.busDispatchStationList = data
    },
    async fetchDriver () {
      const { data } = await driver.list()
      this.option.driverOption = data.map(x => {
        return { text: `${x.name}`, value: x.id }
      }, [])
    },
    async fetchBus () {
      const { data } = await bus.list()
      this.option.busOption = data.map(x => {
        return { text: `${x.carNumber}`, value: x.id }
      }, [])
    },
    async fetchStation () {
      const { data } = await station.list()
      this.option.stationOption = data.map(x => {
        return { text: `${x.name}`, value: x.id, routeGroup: x.routeGroup, routeGroups: x.routeGroups }
      }, [])
    },
    setCreateMode () {
      this.route = { id: 0 }
      this.activeIndex = null
      this.activeChildIndex = null
      this.mode = 'CREATE'
    },
    setCurrentRoute (route) {
      const busDispatchList = this.rawData.busDispatchList
        .filter(x => route.busDispatches.includes(x.id))
        .map(x => {
          return {
            ...x,
            stationList: this.rawData.busDispatchStationList.filter(s => x.stations.includes(s.id))
          }
        }, [])
      this.route = {
        ...route,
        busDispatchList
      }
      this.mode = 'UPDATE'
    },
    addBusDispatch () {
      if (!this.route.busDispatchList) {
        this.$set(this.route, 'busDispatchList', [{ id: 0 }])
      } else {
        this.route.busDispatchList.push({ id: 0 })
      }
    },
    removeBusDispatch (dIndex) {
      if (this.route.busDispatchList[dIndex].id === 0) {
        this.route.busDispatchList.splice(dIndex, 1)
      } else {
        this.$set(this.route.busDispatchList.filter(x => x.remove !== true)[dIndex], 'remove', true)
      }
    },
    addBusDispatchStation (dIndex) {
      const dispatch = this.route.busDispatchList[dIndex]
      if (!dispatch.stationList) {
        this.$set(this.route.busDispatchList[dIndex], 'stationList', [{ id: 0 }])
      } else {
        this.route.busDispatchList[dIndex].stationList.push({ id: 0 })
      }
    },
    setBusDispatchStation (dIndex) {
      const dispatch = this.route.busDispatchList[dIndex]
      if (!dispatch.stationList) {
        this.$set(this.route.busDispatchList[dIndex], 'stationList', [{ id: 0 }])
      } else {
        this.route.busDispatchList[dIndex].stationList.push({ id: 0 })
      }
    },
    removeBusDispatchStation (dIndex, sIndex) {
      if (this.route.busDispatchList[dIndex].stationList[sIndex].id === 0) {
        this.route.busDispatchList[dIndex].stationList.splice(sIndex, 1)
      } else {
        this.$set(this.route.busDispatchList.filter(x => x.remove !== true)[dIndex]
          .stationList.filter(x => x.remove !== true)[sIndex], 'remove', true)
      }
    },
    async createRoute () {
      const { data: createdRoute } = await route.create(this.route)
      for (const i in this.route.busDispatchList) {
        const targetBusDispatch = this.route.busDispatchList[i]
        const { data: createdDispatch } = await busDispatch.create({
          ...targetBusDispatch,
          route: createdRoute.id
        })
        // 정류장 처리
        for (const s in targetBusDispatch.stationList) {
          const targetStation = targetBusDispatch.stationList[s]
          await busDispatchStation.create({
            ...targetStation,
            dispatch: createdDispatch.id
          })
        }
      }
    },
    async updateRoute () {
      await route.set(this.route.id, this.route)
      for (const i in this.route.busDispatchList) {
        const targetBusDispatch = this.route.busDispatchList[i]
        let busDispatchId = targetBusDispatch.id
        if (targetBusDispatch.remove) { // 삭제
          await busDispatch.delete(targetBusDispatch.id)
        } else if (targetBusDispatch.id === 0) { // 생성
          const { data } = await busDispatch.create({
            ...targetBusDispatch,
            route: this.route.id
          })
          busDispatchId = data.id
        } else { // 수정
          if (targetBusDispatch.updateTarget === true) {
            await busDispatch.set(targetBusDispatch.id, targetBusDispatch)
          }
        }
        // 정류장 처리
        if (!targetBusDispatch.remove) {
          for (const s in targetBusDispatch.stationList) {
            const targetStation = targetBusDispatch.stationList[s]
            if (targetStation.remove) {
              await busDispatchStation.delete(targetStation.id)
            } else if (targetStation.id === 0) {
              await busDispatchStation.create({
                ...targetStation,
                dispatch: busDispatchId
              })
            } else {
              if (targetStation.updateTarget === true) {
                await busDispatchStation.set(targetStation.id, targetStation)
              }
            }
          }
        }
      }
    },
    async onSubmit () {
      if (!this.route.routeGroup) {
        eventBus.$emit('alert', { active: true, text: '노선그룹을 선택해주세요.' })
        return
      }
      try {
        eventBus.$emit('showLoading')
        if (this.mode === 'CREATE') {
          await this.createRoute()
          eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
        }
        if (this.mode === 'UPDATE') {
          await this.updateRoute()
          eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
        }
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
        this.fetchRawData()
      }
    },
    onRemoveStation () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '정류장을 정말 제거하시겠습니까?',
          okText: '정류장제거',
          confirmHandler: {
            ok: () => {
            }
          }
        }
      )
    },
    onRemoveRoute () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '노선을 정말 제거하시겠습니까?',
          okText: '노선제거',
          confirmHandler: {
            ok: async () => {
              await route.delete(this.route.id)
              eventBus.$emit('alert', { active: true, text: '제거되었습니다.' })
              this.setCreateMode()
              this.fetchRawData()
            }
          }
        }
      )
    },
    setUpdated (dIndex, sIndex) {
      if (sIndex || sIndex === 0) {
        this.route.busDispatchList[dIndex].stationList[sIndex].updateTarget = true
      } else {
        this.route.busDispatchList[dIndex].updateTarget = true
      }
    },
    selectMainItem (index) {
      this.activeIndex = index
      this.activeChildIndex = null
    },
    selectItem (index) {
      const current = this.$refs.contentMenu.children[this.activeIndex]
      if (current) {
        this.activeChildIndex = index
      }
    },
    isInvalidBusDispatchStations (busDispatchStation) {
      return busDispatchStation.station === null
    },
    isInvalidBusDispatch (busDispatch) {
      if (busDispatch.driver === null) {
        return true
      }
      if (busDispatch.bus === null) {
        return true
      }
      let result = false
      for (const i in (busDispatch.stations || [])) {
        const filterStation = this.rawData.busDispatchStationList.filter(x => x.id === busDispatch.stations[i])
        if (filterStation.length !== 0) {
          result |= this.isInvalidBusDispatchStations(filterStation[0])
        }
      }
      return result
    },
    isInvalidRoute (route) {
      let result = false
      for (const i in (route.busDispatches || [])) {
        const filterBusDispatch = this.rawData.busDispatchList.filter(x => x.id === route.busDispatches[i])
        if (filterBusDispatch.length !== 0) {
          result |= this.isInvalidBusDispatch(filterBusDispatch[0])
        }
      }
      return result
    },
    isInvalidItem (item) {
      let result = false
      for (const i in (item.routes || [])) {
        const filterRoutes = this.rawData.routeList.filter(x => x.id === item.routes[i])
        if (filterRoutes.length !== 0) {
          result |= this.isInvalidRoute(filterRoutes[0])
        }
      }
      return result
    },
    isInvisibleBusDispatch (busDispatch) {
      if (busDispatch.visible === null) {
        return true
      }
      return !busDispatch.visible
    },
    isInvisibleRoute (route) {
      if (!route.visible) {
        return true
      }
      for (const i in (route.busDispatches || [])) {
        const filterBusDispatch = this.rawData.busDispatchList.filter(x => x.id === route.busDispatches[i])
        if (filterBusDispatch.length !== 0) {
          if (!this.isInvisibleBusDispatch(filterBusDispatch[0])) {
            return false
          }
        }
      }
      return true
    },
    isInvisibleItem (item) {
      for (const i in (item.routes || [])) {
        const filterRoutes = this.rawData.routeList.filter(x => x.id === item.routes[i])
        if (filterRoutes.length !== 0) {
          if (!this.isInvisibleRoute(filterRoutes[0])) {
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
  .v-sheet.v-card.bus-route-content {
    background: #f1f6fd;
    border-radius: 0;
    border: none;
    padding-bottom: 20px;
   }

</style>
